(function() {
'use strict';

angular
    .module('parking')
    .service('parkingSearchValidator', parkingSearchValidator);

function parkingSearchValidator(resourceService, dateUtil) {
    const service = {
        validate
    };

    function validate(departureAirport, startDate, endDate) {
        const errors = [];

        if (departureAirport == null) {
            errors.push(resourceService.get('SELECTDEPARTUREAIRPORT'));
        }

        if (startDate == null) {
            errors.push(resourceService.get('SELECTARRIVALDATE'));
        } else if (!dateUtil.atLeastOneDayInTheFuture(startDate)) {
            errors.push(resourceService.get('ARRIVALDATEMUSTBEFUTURE'));
        }

        if (endDate == null) {
            errors.push(resourceService.get('SELECTRETURNDATE'));
        } else if (endDate <= startDate) {
            errors.push(resourceService.get('RETURNDATEAFTERDEPARTUREDATE'));
        }

        return errors;
    }

    return service;
}
})();
